<template>
  <cargo-dialog
    id="app"
    :close-on-click-modal="false"
    :visible="visible"
    :title="title"
    append-to-body
    width="1160px"
    top="5vh"
    @close="cancel"
  >
    <search-item
      ref="searchItem"
      :show-more-scheme="false"
      :show-simple="false"
      :expand-adv="true"
      :col-settings="{span:12}"
      :search-item-code="$t('SeaExport.AddBillCharge')"
      :config-module="searchItemModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      append-to-body
      @advSearchItemCallBack="fetchData"
    />
    <div class="section grid-wrapper" style="display:flex;flex-grow: 1">
      <cargo-ag-grid
        config-module="512100"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :grid-params.sync="gridParams"
        :row-data="rowData"
        :style="{width:'100%',height:'100%','flex-grow':1}"
      />
    </div>
    <div id="footer-wrapper" class="pagination-wrapper">
      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">
        <div v-if="selectedCount > 0"><span>{{ $t('Message.Choose') }} ： {{ selectedCount }}</span></div>
      </div>
      <cargo-pagination
        config-module="512100"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <div slot="footer">
      <el-button no="enterEvent" type="primary" size="mini" @click="enterEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
      <el-button no="cancel" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </cargo-dialog>

</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryCompanyList } from '@/api/company'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'

export default {
  name: 'QueryCompanyDialog',
  components: { CargoDialog, searchItem, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    title: { type: String, default: '' },
    searchItemModule: { type: String, default: '5121' },
    isQueryParentCompany: { type: Boolean, default: true } // 是否查询母公司
  },
  data() {
    return {
      innerVisible: this.visible,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        onSelectionChanged: this.selectionChanged,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        pagination: false
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedCount: 0
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          colId: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          colId: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_abbreviation'),
          field: 'shortName',
          colId: 'shortName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'cnShortName',
          colId: 'cnShortName',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          width: 100,
          cellRenderer: (params) => {
            if (params.value === 1) {
              return 'HQ'
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('baseInfo.partner.contractStatus'),
          field: 'contractStatus',
          colId: 'contractStatus',
          width: 110,
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          }
        },
        {
          headerName: this.$t('baseInfo.partner.isActive'),
          field: 'active',
          colId: 'active',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        },
        {
          headerName: this.$t('baseInfo.partner.dateCreated'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 200,
          cellRenderer: params => {
            return params.value ? params.value.substr(0, 10) : ''
          }
        },
        {
          headerName: this.$t('baseInfo.partner.createBy'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }
      ]
    }
  },
  async created() {
    this.customSearchItemsInit()
  },
  beforeMount() {
  },
  methods: {
    fetchData(conditions) {
      this.searchConditions.snapshotConditions = [...conditions]
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    async toAdvQueryList(conditions) {
      this.loading = getLoading()
      if (conditions && conditions.length > 0) {
        if (AdvancedSearchOption.hasField('companyType', conditions)) {
          const companyType = AdvancedSearchOption.removeOption('companyType', conditions)
          if (companyType.value && companyType.value !== 'ALL') {
            const condition = new AdvancedSearchOption(null, 'company.' + companyType.value, true, OperatorConstants.OPERATOR_EQUAL.code)
            conditions.push(condition)
          }
        }
      }
      if (!this.isQueryParentCompany) {
        const condition = new AdvancedSearchOption(null, 'company.GLOBAL_ACCOUNT_UUID', null, OperatorConstants.OPERATOR_IS_NULL.code)
        conditions.push(condition)
        const condition2 = new AdvancedSearchOption(null, 'company.PARENT_COMPANY', false, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition2)
      }
      queryCompanyList({ conditions, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    enterEvent() { // 确定事件
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('Partners.selectAPartner'))
        return
      }
      this.$emit('enterEvent', chooseRows)
    },
    cancel() {
      this.rowData = []
      this.searchConditions.total = 0
      this.selectedCount = 0
      this.$emit('update:visible', false)
    },
    selectionChanged() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.selectedCount = 0
      } else {
        this.selectedCount = chooseRows.length
      }
    },
    // 签约状态
    contractStatusLabFun(value) {
      let result
      if (Number(value) === 1) {
        result = SeaExportConstants.CONTRACT_STATE_OUT_OF_DATE
      } else if (Number(value) === 2) {
        result = SeaExportConstants.CONTRACT_STATE_SIGNED
      } else {
        result = SeaExportConstants.CONTRACT_STATE_NO
      }
      return this.$i18n.locale === 'zh' ? result.chineseName : result.englishName
    },
    // 自定义高级查询条件初始化
    customSearchItemsInit() {
      const customSearchItems = []
      // 客户类型
      const valueContent = PartnerServiceItem.PARTNER_SERVICE_ITEMS
      const searchField = this.selectAdvancedSearchField('Partners.customerSupplierType', 'companyType', {
        valueType: 'static',
        valueContent
      })
      customSearchItems.push(searchField.formatObj2Json())
      this.customSearchItems = customSearchItems
      if (this.customSearchItems.length > 0) {
        this.searchItemAutoInit = true
      }
    },
    selectAdvancedSearchField(itemLabel, itemName, valueExpression, multiple) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.defaultValue = multiple ? [] : ''
      searchField.multiple = multiple || 0
      searchField.itemLabel = itemLabel || ''
      searchField.itemName = itemName || ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.valueExpression = valueExpression || ''
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
      searchField.action = 2
      return searchField
    }
  }
}
</script>
